import * as ERRORES from "../../../config/constants/step-constants";

const Google = {
  enable() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = function() {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", "AW-685925423");
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-685925423";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.gtag;
  },
  init() {},
  _enviarSnippet(label) {
    window.gtag("event", "conversion", {
      send_to: `AW-685925423/${label}`
    });
  },
  landing() {
    window.google_tag_params = {
      Producto: "Pymes",
      Pasos: "Landing"
    };
  },
  paso1() {
    window.google_tag_params = {
      Producto: "Pymes",
      Pasos: "1"
    };
    Google._enviarSnippet("tgbbCMHxm7MDEK_IiccC");
  },
  oferta() {
    window.google_tag_params = {
      Producto: "Pymes",
      Pasos: "2"
    };
    Google._enviarSnippet("KYlNCMTxm7MDEK_IiccC");
  },
  gracias(context) {
    if (!context.state.isExceeded) {
      window.google_tag_params = {
        Producto: "Pymes",
        Pasos: "3"
      };
      Google._enviarSnippet("9-KGCMfxm7MDEK_IiccC");
    } else {
      window.google_tag_params = {
        Producto: "Pymes",
        Pasos: "x"
      };
      Google._enviarSnippet("CfsVCNPxm7MDEK_IiccC");
    }
  },
  errorOferta() {
    window.google_tag_params = {
      Producto: "Pymes",
      Pasos: "x"
    };
    Google._enviarSnippet("l6fACNDxm7MDEK_IiccC");
  },
  mensaje(context) {
    switch (context.mutation.payload.params.mje) {
      case ERRORES.INDIVIDUO_NEGATIVO:
        window.google_tag_params = {
          Producto: "Pymes",
          Pasos: "x"
        };
        Google._enviarSnippet("9poDCNnxm7MDEK_IiccC");
        break;
      case ERRORES.CLIENTE_ENCONTRADO:
        window.google_tag_params = {
          Producto: "Pymes",
          Pasos: "x"
        };
        Google._enviarSnippet("Vf-CCM3xm7MDEK_IiccC");
        break;
      case ERRORES.CLIENTE_FINANCIADO:
        window.google_tag_params = {
          Producto: "Pymes",
          Pasos: "x"
        };
        Google._enviarSnippet("YGRcCNbxm7MDEK_IiccC");
        break;
      default:
        window.google_tag_params = {
          Producto: "Pymes",
          Pasos: "x"
        };
        Google._enviarSnippet("VRX-CMrxm7MDEK_IiccC");
    }
  }
};

export default Google;
